@let categories = filteredCategoriesSig();
@let isInitialLoading = selectIsInitialLoadingSig();
@let isLoading = selectIsLoadingSig();
@let viewState = viewStateSig();

<div class="ui-tab w-100 h-100 flex-col gap-16">
  @if (isInitialLoading) {
    <ng-container [ngTemplateOutlet]="loader"></ng-container>
  } @else {
    <div class="flex-row space-between-center" [ngClass]="{ 'end-center': viewState === viewStates.INITIAL_EMPTY }">
        @if (viewState !== viewStates.INITIAL_EMPTY) {
          <ui-search style="width: 320px"
                     [searchQuery]="search()"
                     (onInput)="search.set($event)"
                     [placeholder]="'COMMON.SEARCH'|translate">
          </ui-search>
        }
      <ui-button [text]="'COMMON.CREATE'|translate"
                 (click)="create()">
      </ui-button>
    </div>

    @if (search()) {
      <div class="flex-row gap-8 start-center">
        <ui-filter-chip [title]="search()"
                        (removeClicked)="search.set('')">
        </ui-filter-chip>
      </div>
    }
    @if (isLoading) {
      <ng-container [ngTemplateOutlet]="loader"></ng-container>
    } @else {
      @switch (viewState) {
        @case (viewStates.NO_RESULTS) {
          <div class="flex-row center-center w-100 h-100">
            <ui-no-data [imgSrc]="noData.noResults.imgSrc" [title]="noData.noResults.title|translate"></ui-no-data>
          </div>
        }
        @case (viewStates.INITIAL_EMPTY) {
          <div class="flex-row center-center w-100 h-100">
            <ui-no-data [imgSrc]="noData.noData.imgSrc" [title]="noData.noData.title|translate"></ui-no-data>
          </div>
        }
        @case (viewStates.HAS_CONTENT) {
          <ui-dataset-table [data]="categories"
                            [config]="tableConfig"
                            (rowAction)="onRowAction($event)">
          </ui-dataset-table>
        }
      }
    }
  }
</div>

<ng-template #loader>
  <ui-preloader [color]="loaderColor.blue"></ui-preloader>
</ng-template>
